if (!customElements.get('try-all-4-landing')) {
  customElements.define('try-all-4-landing', class TryAll4Landing extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.sticky = this.querySelector('[data-campaign-sticky]');
      const primary = this.querySelector('[data-campaign-primary]');
      const final = this.querySelector('[data-campaign-final]');
      if (!this.sticky || !primary || !final || !('IntersectionObserver' in window)) return;

      this.heroAbove = false;
      this.finalVisible = false;
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.target === primary) {
            this.heroAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          } else if (entry.target === final) {
            this.finalVisible = entry.isIntersecting;
          }
        }
        const show = this.heroAbove && !this.finalVisible;
        this.sticky.hidden = !show;
        this.sticky.classList.toggle('mb4-show', show);
      });
      this.observer.observe(primary);
      this.observer.observe(final);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
